az<template>
  <div class="post-comment">
    <div class="todo-comment">
      <div class="textarea">
        <el-input v-model="content" :rows="row" type="textarea" placeholder="请输入"></el-input>
      </div>
      <div class="button" @click="add">
        发布
      </div>
    </div>
  </div>
</template>

<script>
import { commentAdd } from '@/api/commentApi'

export default {
  name: 'h-comment',
  props:{
    businessId:null,
    type:'',
    row:{
      type:Number,
      default:3
    }
  },
  computed: {
    getAvatar() {
      return this.$store.getters.avatar;
    },
  },
  data(){
    return{
      content:'',
    }
  },
  methods:{
    add(){
      if(this.content){
        const $this = this;
        let comment = {};
        comment.content = this.content;
        comment.type = this.type;
        comment.businessId = this.businessId;
        commentAdd(comment).then(res =>{
          if(res && res.code == 200){
            $this.$message.success("发布成功");
            $this.content = '';
            $this.$emit('success')
          }else if(res.code == 401){
            $this.$message.warning("请登录");
          }
        })
      }
      // this.$emit('add',this.content,this.businessId);

    }
  },
}
</script>

<style scoped>

.todo-comment{
  display: flex;
  padding: 10px;
  background: #fff;
}
.todo-comment .textarea{
  width: 90%;
}
.todo-comment .button{
  width: 10%;
  margin-top: auto;
  cursor:pointer;
}
</style>
